import styled from 'styled-components';

const BrandContainer = styled.div`
  width: 1230px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0 50px;
`;
const BrandImg = styled.div``;

export const style = { BrandContainer, BrandImg };
